import { ICategoryType, ISessionType } from '@wot/typings';
import xhr from '../utils/fetch';

export interface AddPayload {
  userId: string;
  tutorId: string;
  category: {
    board?: string | undefined;
    grade?: string | undefined;
    name: string;
    type?: string | undefined;
    level?: string | undefined;
  };
  type: ISessionType;
  sessionDuration: 60;
  categoryType: ICategoryType;
  scheduledTime: {
    start: string;
    end: string;
  };
}

const get = async (userId: string, filters?: any) => {
  return await xhr({
    url: `/u/${userId}/sessions`,
    method: 'GET',
    params: filters
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

async function add(userId: string, payload: AddPayload) {
  return await xhr({
    url: `/u/${userId}/sessions`,
    method: 'POST',
    body: payload
  })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
}

const update = async (userId: string, sessionId: string, payload: any) => {
  return await xhr({
    url: `/u/${userId}/sessions/${sessionId}`,
    method: 'PUT',
    body: payload
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export const sessionsApi = {
  get,
  add,
  update
};
